import fs from 'fs';
import path from 'path';

export const getPackageJsonForPath = (root: string): any => {
  for (let dir = root; path.dirname(dir) !== dir; dir = path.dirname(dir)) {
    const file = path.resolve(dir, 'package.json');
    if (fs.existsSync(file)) {
      return require(file);
    }
  }
  return null;
};
